<template>
  <div class="position-relative" v-click-outside="hide">
    <button class="btn-link-alt" @click="clickHandler()">
      <span class="align-middle ml-0">{{ name }}</span>
      <slot name="btn-icon">
        <svg-icon icon="chevron-down" class="align-middle ml-1 mr-0" />
      </slot>
    </button>
    <transition name="fade">
      <box v-if="isShow" class="p-0 dimension-dropdown">
        <div class="clearfix border-bottom d-block d-lg-none">
          <button @click="isShow = false" class="btn-link-alt float-right mr-2">
            <svg-icon icon="cross" class="icon-sm" />
          </button>
        </div>
        <dimension-menu
          :name="name"
          :uniq-key="uniqKey"
          :filters="filters"
          @submit="submit"
          :custom-empty-text="customEmptyText"
        >
          <div slot="settings">
            <slot name="settings" />
          </div>
          <slot name="dimension-menu" />
        </dimension-menu>
      </box>
    </transition>
  </div>
</template>

<script>
import DimensionMenu from './DimensionMenu.vue';
import ListSegments from './ListSegments.vue';

export default {
  props: {
    name: {
      type: String,
      default: 'Select'
    },
    filters: {
      type: Array,
      default: () => []
    },
    uniqKey: {
      type: String,
      default: 'name'
    },
    customEmptyText: {
      type: String,
      default: ''
    }
  },

  components: {
    DimensionMenu,
    ListSegments
  },

  data() {
    return {
      isShow: false
    };
  },

  methods: {
    hide() {
      this.isShow = false;
    },

    submit(segment) {
      this.$emit('submit', segment);
      this.isShow = false;
    },

    clickHandler() {
      this.isShow = !this.isShow;
      if (this.name === 'segments') {
        this.$emit('get-segments');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dimension-dropdown {
  width: 300px;
  position: absolute;
  z-index: $zindex-dropdown;
  top: 100%;
  left: 0;
  margin-top: 0.5rem;
  text-align: left;
}

@include media-breakpoint-down(md) {
  .dimension-dropdown {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: $zindex-fixed + 1;
    margin-top: 0;
    border: none !important;
  }
}
</style>
